import AOS from 'aos';
import initializeMobileMenu from './menu';
import initializeFixedMenu from './utils/fixed-menu';
import initializeBlockLogotypes from './blocks/logotypes';
import initializeBlockPlaceSlider from './blocks/place-slider';
import initializeSliderMain from './blocks/slider-main';
import initializeGallerySlider from './blocks/gallery';
import initializeBlockSliderTextImage from './blocks/slider-text-image';
import initializeFancybox from "./utils/fancybox";
import initializeMap from "./blocks/map-osm";
import initializeSingleMap from "./utils/single-map-osm";
import initializeJobOffers from './blocks/job-offers';
import blockBrands from './blocks/brands';
import initPopup from './utils/popup';
import contactFormTurnstile from './utils/contact';
import initializeBlockFiles from './blocks/files';
import initializeBlockCollapse from './blocks/collapse';
import initializeItemsWithCollapse from './blocks/items-with-collapse';
import initializeWcag from './wcag.js';
// import WooCommerce from './woo'

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        AOS.init({
            disable: 'mobile',
            once: true,
            duration: 1000
        });
        initPopup();
        initializeJobOffers();
        initializeMobileMenu();
        initializeFixedMenu();
        initializeBlockLogotypes();
        initializeBlockSliderTextImage();
        initializeBlockPlaceSlider();
        initializeSliderMain();
        initializeFancybox();
        initializeGallerySlider();
        initializeMap();
        blockBrands();
        initializeSingleMap();
        contactFormTurnstile();

    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
